/**
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 *
 * This file is generated by generate-feature-flags.ts from feature-flags-registry.json.
 * To add or modify feature flags, edit feature-flags-registry.json and run: npm run generate:feature-flags
 *
 * @generated
 * @hash c0618d70fa00c10a
 */

const MatchmakingFlags = [
  'isMatchmakingCustomizationExperimentsAllowed',
  'isMatchmakingCustomizationAllowed',
  'isMatchmakingTextChatSignalEnabled',
] as const;

export default MatchmakingFlags;
